import ProductsNavSection from './ProductsNavSection';
import { useFlagsProxy } from '@modules/feature-flags/hooks/useFlagsProxy';
import { useOrganization } from 'app/_providers/Organization';
import { useWorkspace } from 'app/_providers/WorkspaceProvider';

import React from 'react';

const SettingsSection: React.FC = () => {
  const { cloudControlPlaneCdnUi } = useFlagsProxy();
  const { leaderFQDN, name: workspaceName } = useWorkspace();
  const { organizationId } = useOrganization();

  const hrefRoot = cloudControlPlaneCdnUi
    ? `https://app.${process.env.SHARED_DOMAIN}/organizations/${organizationId}/workspaces/${workspaceName}/app`
    : `https://${leaderFQDN}`;

  const settingsItems = [
    {
      title: 'Settings',
      link: `${hrefRoot}/global-settings`,
      className: 'settings-item',
    },
  ];

  return (
    <div
      className='settings-item-container'
      style={{ fontWeight: 200 }}
    >
      <ProductsNavSection
        productKey='settings'
        items={settingsItems}
      />
    </div>
  );
};

export default SettingsSection;
